import { create } from "zustand"

interface RoomBootstrapStore {
  /** Set when `subscribeRoom` throws before the room feed is established (config/auth/client). */
  subscriptionInitFailed: boolean
  /** True after `/v1/bootstrap` has completed and seeded initial room/balance data. */
  bootstrapReady: boolean
  setSubscriptionInitFailed: (failed: boolean) => void
  setBootstrapReady: (ready: boolean) => void
}

export const useRoomBootstrapStore = create<RoomBootstrapStore>((set) => ({
  subscriptionInitFailed: false,
  bootstrapReady: false,
  setSubscriptionInitFailed: (failed) =>
    set({ subscriptionInitFailed: failed }),
  setBootstrapReady: (ready) => set({ bootstrapReady: ready }),
}))
